type OfflinePreparation = { status: 'idle' } | { status: 'preparing' | 'ready'; result: Promise<void> };
let preparation: OfflinePreparation = { status: 'idle' };

/** Control the initial map requests without delaying them for the asset download. */
export function prepareOfflineEditor(): Promise<void> {
  if (preparation.status !== 'idle') return preparation.result;
  if (!('window' in globalThis) || !('serviceWorker' in navigator)) return Promise.resolve();
  if (window.location.pathname !== '/' && !/^\/m\/[^/]+\/?$/.test(window.location.pathname)) return Promise.resolve();
  const result = new Promise<void>(resolve => {
    const finish = () => { clearTimeout(timeout); navigator.serviceWorker.removeEventListener('controllerchange', controlled); resolve(); };
    const controlled = () => { if (navigator.serviceWorker.controller) finish(); };
    // A failed worker must not prevent the online editor from opening.
    const timeout = setTimeout(finish, 1500);
    navigator.serviceWorker.addEventListener('controllerchange', controlled);
    void navigator.serviceWorker.register('/offline-sw.js').then(async () => {
      const registration = await navigator.serviceWorker.ready;
      registration.active?.postMessage({ type: 'prepare-editor' });
      controlled();
    }).catch(finish);
  });
  preparation = { status: 'preparing', result };
  void result.then(() => { preparation = { status: 'ready', result }; });
  return result;
}
